/**
 * @file index.tsx
 *
 * @fileoverview Renders link referring to the font styles file.
 */
import localFont from 'next/font/local';
const spaceGrotesk = localFont({
  src: [
    {
      path: './../../../../../public/fonts/woff2/SpaceGrotesk-regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './../../../../../public/fonts/woff2/SpaceGrotesk-semibold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: './../../../../../public/fonts/woff2/SpaceGrotesk-bold.woff2',
      weight: '900',
      style: 'regular',
    },
  ],
});

export const NextFontSlot = ({ children }) => (
  <div className={spaceGrotesk.className}>
    {children}
    <style jsx global>{`
      :root {
        --font-family-body: ${spaceGrotesk.style.fontFamily};
        --font-family-headings: ${spaceGrotesk.style.fontFamily};
      }
    `}</style>
  </div>
);
